import { Avatar, Card, CircularProgress, Grid } from "@mui/material";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { AiOutlineCamera } from "react-icons/ai";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { FiLock } from "react-icons/fi";
import { UserContext } from "../../App";
import Custombutton from "../../Common/Custombutton";
import Loder from "../../Loder/Loder";
import { notificationHandler } from "../../utils/Notification";
import get_admin_profile_api, {
  profile_update_admin_api,
} from "../api/profile";
import s from "./members.module.css";
import { useNavigate } from "react-router-dom";
import { addRole_api, getRole_api } from "../api/role";
import { addMember_api } from "../api/members";
import { BiArrowBack } from "react-icons/bi";
import AddRole from "../Role/AddRole";
const AddMemeber = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const { state, dispatch } = useContext(UserContext);
  const [profile_img, setprofile_img] = useState("");
  const [showPass, setshowPass] = useState(false);
  const [profiledata, setprofiledata] = useState({
    name: "",
    email: "",
    password: "",
    last_name: "",
    phone: "",
    status: "",
  });
  const [assignRole, setassignRole] = useState("");
  const [updateCount, setUpdateCount] = useState(0);
  const [subAdminPermission, setSubAdminPermission] = useState();
  console.log(
    subAdminPermission,
    " subAdminPermission subAdminPermission subAdminPermission "
  );
  const updateMembersDetails = (e) => {
    setprofiledata({
      ...profiledata,
      [e.target.name]: e.target.value,
    });
  };

  const createMemberFunc = async () => {
    const temp = {
      name: profiledata.name,
      password: profiledata.password,
      email: profiledata.email,
      status: profiledata?.status,
      phone: profiledata?.phone,
      access_tabs: subAdminPermission,
    };

    try {
      let res = await addMember_api(temp);
      if (res.data.success) {
        navigate("/members-list");
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        notificationHandler({ type: "success", msg: res.data.message });
      }
    } catch (error) {
      notificationHandler({ type: "danger", msg: error.message });
      console.log(error);
    }
  };

  //    this api for the lsiting of the roles
  const [role, setrole] = useState([]);
  useEffect(() => {
    fetchroleFunc();
  }, []);

  async function fetchroleFunc(data) {
    setisLoading(true);
    try {
      const temp = {};
      let res = await getRole_api(temp);
      if (res.data.status) {
        setrole(res?.data?.data);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <section className={s["profile-page"]}>
        <div className={s["title"]} onClick={() => navigate(-1)}>
          <BiArrowBack />
          Back
        </div>
        <Card>
          <div className={s["profile-container"]}>
            <div className="profile-content">
              {/* <div className="user-profile-image">
                <div className={s["profile_details"]}>
                  <div className={s["avatar"]}>
                    {!imgloading ? (
                      <Avatar
                        alt="Profile Pic"
                        src={profile_img}
                        style={{ height: "8rem", width: "8rem" }}
                        refreshCount={updateCount}
                      />
                    ) : (
                      <CircularProgress />
                    )}
                    <label>
                      <AiOutlineCamera className={s["camera_icon"]} />
                      <input
                        type="file"
                        // onChange={(e) => changePicFunc(e)}
                        name="myfile"
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>
                </div>
              </div> */}
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={6}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={profiledata.name}
                      name="name"
                      onChange={(e) => updateMembersDetails(e)}
                      placeholder="Name"
                    />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Phone</label>
                    <input
                      type="number"
                      className="form-control"
                      value={profiledata.phone}
                      name="phone"
                      onChange={(e) => updateMembersDetails(e)}
                      placeholder="phone no."
                    />
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Password</label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control"
                        type={showPass ? "text" : "password"}
                        value={profiledata.password}
                        onChange={(e) => updateMembersDetails(e)}
                        name="password"
                      />
                      {showPass ? (
                        <BsEyeSlash
                          className={s.showHideEye}
                          style={{ color: "#000" }}
                          onClick={() => setshowPass(false)}
                        />
                      ) : (
                        <BsEye
                          className={s.showHideEye}
                          style={{ color: "#000" }}
                          onClick={() => setshowPass(true)}
                        />
                      )}
                    </div>
                  </div>
                  <div></div>
                </Grid>
                <Grid item xs={6}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={profiledata.email}
                      name="email"
                      onChange={(e) => updateMembersDetails(e)}
                      placeholder="Email"
                    />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Status</label>
                    <div className="  mr-2">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="status"
                          value={profiledata?.status}
                          onChange={(e) => updateMembersDetails(e)}
                          id="exampleFormControlSelect1"
                        >
                          <option>Select Type </option>
                          <option value="Active">Active </option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <AddRole setSubAdminPermission={setSubAdminPermission} />
            </div>
            <div className={s["form-login-btn"]} onClick={createMemberFunc}>
              <Custombutton>Submit</Custombutton>
            </div>
          </div>
        </Card>
      </section>
      <Loder loading={isLoading} />
    </>
  );
};

export default AddMemeber;
